export enum ApartmentEnum {
    LUNA = 'LUNA',
    WEGA = 'WEGA'
}